import { render, staticRenderFns } from "./TransactionHistoryGroup.vue?vue&type=template&id=6524d795&scoped=true&"
import script from "./TransactionHistoryGroup.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryGroup.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryGroup.vue?vue&type=style&index=0&id=6524d795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524d795",
  null
  
)

export default component.exports